import type { ModelConfigMapper } from "./model.type";

export const MODEL_CONFIG_MAPPER: ModelConfigMapper = {
  activity: {
    apiKey: "activities",
    queryKey: "activities",
    route: "/activities",
    authorizationKeys: { create: null, view: "activity" },
    restore: true,
  },
  asset: {
    apiKey: "assets",
    queryKey: "assets",
    route: "/assets",
    authorizationKeys: { create: "asset", view: null },
    deleteAsync: true,
    restore: true,
  },
  assettype: {
    apiKey: "assetTypes",
    queryKey: "assetTypes",
    route: "/asset-types",
    authorizationKeys: { create: "assettype", view: null },
    translationKey: "assetType",
    restore: true,
  },
  comment: {
    apiKey: "comments",
    queryKey: "observations.comments",
    route: null,
    authorizationKeys: { create: null, view: null },
    translationKey: "comment",
    restore: false,
  },
  dataset: {
    apiKey: "datasets",
    queryKey: "datasets",
    route: null,
    authorizationKeys: { create: null, view: null },
    restore: true,
  },
  entitytemplate: {
    apiKey: "entityTemplates",
    queryKey: "entityTemplates",
    route: null,
    authorizationKeys: { create: "entitytemplate", view: null },
    restore: false,
  },
  intervention: {
    apiKey: "interventions",
    queryKey: "interventions",
    route: "/interventions",
    authorizationKeys: { create: "intervention", view: null },
    restore: true,
  },
  interventiontemplate: {
    apiKey: "interventionTemplates",
    queryKey: "interventionTemplates",
    route: "/intervention-templates",
    authorizationKeys: { create: "interventiontemplate", view: null },
    translationKey: "interventionTemplate",
    restore: true,
  },
  jobmodule: {
    apiKey: "jobModules",
    queryKey: "jobModules",
    route: null,
    authorizationKeys: { create: null, view: null },
    restore: false,
  },
  location: {
    apiKey: "locations",
    queryKey: "locations",
    route: "/locations",
    authorizationKeys: { create: "location", view: "location" },
    deleteAsync: true,
    restore: true,
  },
  observation: {
    apiKey: "observations",
    queryKey: "observations",
    route: "/observations",
    authorizationKeys: { create: null, view: null },
    restore: false,
  },
  organization: {
    apiKey: "organizations",
    queryKey: "organizations",
    route: "/organizations",
    authorizationKeys: { create: "organization", view: "organization" },
    deleteAsync: true,
    restore: true,
  },
  project: {
    apiKey: "projects",
    queryKey: "projects",
    route: "/projects",
    authorizationKeys: { create: "project", view: "project" },
    restore: true,
  },
  recommendation: {
    apiKey: "recommendations",
    queryKey: "recommendations",
    route: null,
    authorizationKeys: { create: null, view: null },
    restore: true,
  },
  sector: {
    apiKey: "locations",
    queryKey: "locations",
    route: "/locations",
    authorizationKeys: { create: "location", view: "location" },
    translationKey: "sector",
    deleteAsync: true,
    restore: true,
  },
  severitygrid: {
    apiKey: "severityGrids",
    queryKey: "severityGrids",
    route: null,
    authorizationKeys: { create: null, view: null },
    translationKey: "severityGrids",
    restore: false,
  },
  technicalform: {
    apiKey: "entityTemplates",
    queryKey: "entityTemplates",
    route: "/technical-forms",
    authorizationKeys: { create: "entitytemplate", view: null },
    translationKey: "technicalForm",
    restore: false,
  },
  user: {
    apiKey: "users",
    queryKey: "users",
    route: "/users",
    authorizationKeys: { create: "user", view: "user" },
    restore: true,
  },
};
